import api from "./httpService";

const readArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; items?: unknown; types?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.types)) return data.types;
    }
    return [];
};

export const getExpensesTypeService = async () => {
    const response = await api.get("/expensesType");
    return readArray(response.data);
};

export const addExpenseService = async (payload: Record<string, unknown>) => {
    const response = await api.post("/expenses", payload);
    return response.data;
};

export const getExpensesService = async (
    filters?: { startDate?: string; endDate?: string }
) => {
    const params = new URLSearchParams();
    if (filters?.startDate) params.set("startDate", filters.startDate);
    if (filters?.endDate) params.set("endDate", filters.endDate);

    const query = params.toString();
    const response = await api.get(`/expenses${query ? `?${query}` : ""}`);
    return readArray(response.data);
};
